export const ACTION = {
    GET_FUND_DETAILS:'GET_FUND_DETAILS',
    GET_ALL_SCHEME_DETAILS:'GET_ALL_SCHEME_DETAILS',
    GET_TRENDING_FUND_JAVA: 'GET_TRENDING_FUND_JAVA',
    SEND_OTP_ECART: 'SEND_OTP_ECART',
    RESEND_OTP_ECART: 'RESEND_OTP_ECART',
    SAVE_PRELOGIN_ECART: 'SAVE_PRELOGIN_ECART',
    UPDATE_ECART_FOLIO_ECART: 'UPDATE_ECART_FOLIO_ECART',
    SAVE_KYC_DATA:'SAVE_KYC_DATA',
    GET_FILTER_LIST:'GET_FILTER_LIST'
};

export const SCHEME_FILTERS = {
    FUND_CATEGORY:{
        id:'1',
        name:'Fund Category',
        list:['Diversified Equity','Index','Thematic/Sectoral Equity','Equity Linked Savings Scheme(ELSS)','Hybrid','Solution Oriented','Theme Based Debt','Duration Based Debt','ETF','Fund of Funds']
    },
    TIME_HORIZON:{
        id:'2',
        name:'Time Horizon',
        list:['Short Term (1 year)','Medium Term (1-3 year)','Long Term (3 year +)']
    },
    GOALS:{
        id:'3',
        name:'Goals',
        list: ['Wealth Creation','Tax Saving',"Children Fund",'Retirement Planning','Income Solutions']
    },
    RISK_RATING:{
        id:'4',
        name:'Risk Rating',
        list: ['Low risk','Low to Moderate Risk','Moderate Risk','Moderately High Risk','High Risk','Very High Risk']
    }
}

export const DURATION_OPTIONS = {
    1: {name:'1 Year', value:1},
    3: {name:'3 Years', value:3},
    5: {name:'5 Years', value:5},
    10: {name:'10 Years', value:10},
    11: {name:'Since Inception', value:11}
}

export const NUM_TO_WORD = {
    1:'First',
    2:'Second',
    3:'Third',
    4:'Fourth'
}